export default {
  'primary': '#07B2FD',
  'secondary': '#303030',
  'accent': '#07B2FD'
}
